<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :mini-variant="mini"
      right
      temporary
      fixed
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
      v-model="drawer"
    >
      <v-layout column ma-0 pa-0>
        <v-layout row>
          <v-progress-linear color="success" :indeterminate="loading" v-show="loading"></v-progress-linear>
          <v-spacer></v-spacer>
          <v-btn color="primary" icon @click="getMenus">
            <v-icon>mdi-database-refresh</v-icon>
          </v-btn>
        </v-layout>
        <v-divider></v-divider>
        <el-tree :data="menus" accordion @node-click="menuNodeClick">
          <div slot-scope="{node,data}">
            <v-icon color="primary">{{data.icon}}</v-icon>
            {{data.Name}}
          </div>
        </el-tree>
        <!-- <gh-tree :data="svGetMenus.data" :accordion="true">

        </gh-tree>-->
      </v-layout>
    </v-navigation-drawer>
    <v-toolbar
      :color="appconfig.color"
      dark
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
      dense
    >
      <v-toolbar-title style="width: 600px" class="ml-0 pl-3">
        <v-layout row wrap align-center>
          <v-flex xs2>
            <gh-img :id="loginer.Site.Logo" :max-height="35"></gh-img>
            <!-- <v-img src="/img/logo.png" height="55" contain></v-img> -->
          </v-flex>
          <v-divider vertical style="margin-left:10px;margin-right:10px"/>
          <v-flex xs3 md2 lg1>
            <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
            <span class="hidden-sm-and-down">{{loginer.Site.AppName===undefined?'智慧平台':loginer.Site.AppName}}</span>
          </v-flex>
        </v-layout>
      </v-toolbar-title>
      <v-divider vertical></v-divider>
      <v-icon v-show="title!==''" style="margin-left:10px;margin-right:10px">mdi-hand-pointing-right</v-icon>
      <!-- <v-subheader class="hidden-sm-and-down">当前页面</v-subheader> -->
      <span class="font-weight-regular title">{{title}}</span>

      <v-spacer></v-spacer>
      <v-divider vertical></v-divider>
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left-bold-outline</v-icon>
      </v-btn>
      <v-btn icon @click="$router.go(1)">
        <v-icon>mdi-arrow-right-bold-outline</v-icon>
      </v-btn>
      <v-divider vertical></v-divider>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="100" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="goRealtimeMessage">
            <v-badge overlap color="red" v-model="noticeMessage.isShow">
              <template v-slot:badge>
                <span>!</span>
              </template>
              <v-icon>notifications</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <!-- <v-card>
          <v-card-text primary-title>
            <h4>{{noticeMessage.datetime}}</h4>
            {{noticeMessage.message}}
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="orange" @click="goRealtimeMessage(false)">忽略全部</v-btn>
            <v-spacer />
            <v-btn small color="primary" @click="goRealtimeMessage">查看</v-btn>
          </v-card-actions>
        </v-card> -->
      </v-menu>
      <v-divider vertical></v-divider>
      <v-btn icon large>
        <v-avatar size="32px" tile>
          <gh-img :id="loginer.User.Logo"></gh-img>
          <!-- <img src="/favicon.ico" alt="Vuetify"> -->
        </v-avatar>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container fluid pa-0>
        <gh-progress :show="isBusy"></gh-progress>
        <gh-confirm-dialog ref="confirmDialog"></gh-confirm-dialog>
        <v-layout>
          <v-flex>
            <v-layout column>
              <v-toolbar dense flat color="white">
                <v-toolbar-side-icon @click="goWorkstation">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon color="primary" v-on="on">mdi-home</v-icon>
                    </template>
                    <span>工作台</span>
                  </v-tooltip>
                </v-toolbar-side-icon>
                <v-toolbar-title>
                  <v-chip
                    close
                    small
                    :color="item.value===title?'primary':'#C0C0C0'"
                    text-color="white"
                    class="body-2"
                    v-for="item in history_menus"
                    :key="item.name"
                    @click="navigate(item.name, {}, item.value)"
                    v-model="item.show"
                    @input="closeNav(item)"
                  >{{item.value}}</v-chip>
                </v-toolbar-title>
                <v-spacer/>
                <v-toolbar-items class="hidden-sm-and-down">
                  <v-btn icon>
                    <v-icon></v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-divider />
              <keep-alive :max="10">
                <router-view :key="this.$route.name"/>
              </keep-alive>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer app right>
      <!-- <v-img contain src="/ghzc.png" :height="30"></v-img> -->
      <v-spacer></v-spacer>
      <span class="black--text">&copy;</span>
      <!-- <v-spacer></v-spacer> -->
    </v-footer>
  </v-app>
</template>

<style scoped>
</style>

<script>
import Main from "./main.ts";
export default Main;
</script>